enum AppHeaders {
  AdminToken = 'X-Admin-Token',
  RecaptchaToken = 'x-recaptcha-token',
}

export default AppHeaders;
